// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8489":"css/admin-app.6822","9401":"css/app.6822"}[chunkId] + ".css";
};